import axios from 'axios';
import storage from 'good-storage';
import store from '@/store/index';
import route from '@/router';

let ajaxFor = axios.create({
    baseURL: 'http://wap.china1904.com',
    timeout: 300000
})

ajaxFor.interceptors.request.use(function(config){
    if(storage.get('userInfo')){
        config.headers['X-Token'] = storage.get("userInfo").token;
    }
    return config;
},function(error){
    return Promise.reject(error);
})

ajaxFor.interceptors.response.use(response => {
    if(response.status){
        let resData = response.data.payload;
        if(resData.resultStatus && resData.resultStatus.status > 0){
            if(resData.resultStatus.status == 130033){
                storage.remove("userInfo");
                store.dispatch('user/AuserClean');
            }
            return Promise.reject(response.data.payload.resultStatus.message);

        }else{
            return Promise.resolve(response.data.payload);
        }
    }else{
        return Promise.reject('网络错误，请稍后重试！');
    }
},error => {
    if(error.message == 'Network Error'){
        return Promise.reject('网络错误，请稍后重试！');
    }else if(error.message==='timeout of 200000ms exceeded'){
        return Promise.reject('请求已超时！');
    }else{
        return Promise.reject('操作有误！');
    }
    return Promise.reject(error);

})


export default ajaxFor;
